import { PayloadAction } from "@reduxjs/toolkit";
import { GroupsState } from "../../models/GroupsState";
import { GetSelectedServicePayload } from "../../payload/GetSelectedService/GetSelectedServicePayload";

const getSelectedServiceFetch = (state: GroupsState, action: PayloadAction<GetSelectedServicePayload>) => {
    state.isLoading = true;
}

export default getSelectedServiceFetch;